export class TheMovieDb {
  constructor(public cast?: Cast[], public crew?: Crew[]) {}
}

export class Cast {
  constructor(
    public adult: boolean,
    public cast_id: number,
    public character: string,
    public credit_id: string,
    public gender: number,
    public id: number,
    public known_for_department: string,
    public name: string,
    public order: number,
    public original_name: string,
    public popularity: number,
    public profile_path: string,

  ) {}
}

// adult: false adult:boolean,castId:number,character:string,creditId:string,gender:number,id:number,knownForDepartment:string,name:string
// cast_id: 3
// character: "Andy Dufresne"
// credit_id: "52fe4231c3a36847f800b131"
// gender: 2
// id: 504
// known_for_department: "Acting"
// name: "Tim Robbins"
// order: 0
// original_name: "Tim Robbins"
// popularity: 4.077
// profile_path: "/hsCu1JUzQQ4pl7uFxAVFLOs9yHh.jpg"
export class Crew {
  constructor(
    public adult: boolean,
    public cast_id: number,
    public character: string,
    public credit_id: string,
    public gender: number,
    public id: number,
    public known_for_department: string,
    public name: string,
    public order: number,
    public original_name: string,
    public popularity: number,
    public profile_path: string,
    public department: string,
    public job?:string
  ) {}
}

// adult: false
// credit_id: "52fe4231c3a36847f800b153"
// department: "Sound"
// gender: 2
// id: 153
// job: "Original Music Composer"
// known_for_department: "Sound"
// name: "Thomas Newman"
// original_name: "Thomas Newman"
// popularity: 1.802
// profile_path: "/j8rIiOSdBjtDL5vji8m5BtChZou.jpg"

export class PersonDetail {
  constructor(
    public adult?: boolean,
    public also_known_as?: Array<string>,
    public biography?: string,
    public birthday?: string,
    public deathday?: string,
    public gender?: number,
    public homepage?: string,
    public id?: number,
    public imdb_id?: string,
    public profile_path?: string,
  ) {}
}

// {
//   "adult": false,
//   "also_known_as": [
//       "​Timothy Francis \"Tim\" Robbins",
//       "蒂姆·罗宾斯",
//       "Тим Роббинс",
//       "팀 로빈스",
//       "تیم رابینز"
//   ],
//   "biography": "Timothy Francis Robbins (born October 16, 1958) is an American actor, screenwriter, director, producer, and musician. He is best known for his portrayal of Andy Dufresne in the prison drama film The Shawshank Redemption (1994).",
//   "birthday": "1958-10-16",
//   "deathday": null,
//   "gender": 2,
//   "homepage": "https://timrobbins.net/",
//   "id": 504,
//   "imdb_id": "nm0000209",
//   "known_for_department": "Acting",
//   "name": "Tim Robbins",
//   "place_of_birth": "West Covina, California, USA",
//   "popularity": 7.989,
//   "profile_path": "/hsCu1JUzQQ4pl7uFxAVFLOs9yHh.jpg",
//   "images": {
//       "profiles": [
//           {
//               "aspect_ratio": 0.666,
//               "height": 1652,
//               "iso_639_1": null,
//               "file_path": "/hsCu1JUzQQ4pl7uFxAVFLOs9yHh.jpg",
//               "vote_average": 5.264,
//               "vote_count": 8,
//               "width": 1101
//           },
//           {
//               "aspect_ratio": 0.666,
//               "height": 1024,
//               "iso_639_1": null,
//               "file_path": "/9DujxnBMVkizaeIyM0eXPMfXxR.jpg",
//               "vote_average": 5.186,
//               "vote_count": 20,
//               "width": 682
//           },
//           {
//               "aspect_ratio": 0.667,
//               "height": 3000,
//               "iso_639_1": null,
//               "file_path": "/A4fHNLX73EQs78f2G6ObfKZnvp4.jpg",
//               "vote_average": 5.118,
//               "vote_count": 4,
//               "width": 2000
//           }
//       ]
//   }
// }
